module.exports = __webpack_public_path__ + "static/media/norequest.d6ce1e7c.png";